import { NEW_HOME_SECTION_VIEWED_NAME_PLP } from './homePageSectionViewed';

/** Fired when the user opens the home recommended (PLP) facet filter UI (desktop strip or mobile nav filter). */
export const HOME_PAGE_PLP_FILTER_CLICKED = 'Home Page PLP Filter Clicked';

export function homePagePlpFilterClickedEventProperties(): Record<string, string> {
  return {
    'Section Name': NEW_HOME_SECTION_VIEWED_NAME_PLP,
  };
}
